import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
//import { eventHub } from './common/eventhub'
import store from '../store'
import deferred from 'vue-deferred'

/*
    axios 인스턴스를 생성합니다.
    생성할때 사용하는 옵션들 (baseURL, timeout, headers 등)은 다음 URL에서 확인할 수 있습니다.
    https://github.com/axios/axios 의 Request Config 챕터 확인

*/
console.log(process.env)
const instance = axios.create({
    timeout: 60000,
    baseURL : process.env == 'test' ? '' : ''
    // headers: {'X-Custom-Header': 'foobar'}
});

/*
    1. 요청 인터셉터를 작성합니다.
    2개의 콜백 함수를 받습니다.
    1) 요청 바로 직전 - 인자값: axios config
    2) 요청 에러 - 인자값: error
*/
instance.interceptors.request.use(
    function (config) {
        // 요청 바로 직전
        // axios 설정값에 대해 작성합니다.
        console.log("req success", config)
        
        store.dispatch('common/callMutation', {flag:true});
        NProgress.start();
        return config;
    }, 
    function (error) {
        // 요청 에러 처리를 작성합니다.
        console.log("req error", error)
        store.dispatch('common/callMutation', {flag:false});
        NProgress.done();
        return Promise.reject(error);
    }
);

/*
    2. 응답 인터셉터를 작성합니다.
    2개의 콜백 함수를 받습니다.
    1) 응답 정성 - 인자값: http response
    2) 응답 에러 - 인자값: http error
*/
instance.interceptors.response.use(
    function (response) {
    /*
        http status가 200인 경우
        응답 바로 직전에 대해 작성합니다. 
        .then() 으로 이어집니다.
    */
        console.log("res success", response)
        store.dispatch('common/callMutation', {flag:false});
        NProgress.done();
        return response;
    },

    function (error) {
    /*
        http status가 200이 아닌 경우
        응답 에러 처리를 작성합니다.
        .catch() 으로 이어집니다.    
    */
        console.log("res error", error)
        store.dispatch('common/callMutation', {flag:false});
        NProgress.done();
        return Promise.reject(error);
    }
);

// ajax methodsss
instance.json = async function(url = "", param = {}) {
    if(url == "") return Promise.reject("no Request URL");
    return await instance.post(url, param, {
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }})
}

instance.reqPost = async function(url = "", param = {}) {
    if(url == "") return Promise.reject("no Request URL");

    const data = new URLSearchParams()
    for (const key in param) {
        data.append(key, param[key])
    }

    return await instance.post(url, data.toString(),
        {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
        }
    })
}

instance.form = async function(url = "", formData) {
    if(url == "") return Promise.reject("no Request URL");

    return await instance.post(url, formData,
        {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

instance.all = function(promiseList){
    var defer = deferred()
    Promise.all(promiseList)
    .then(defer.resolve)
    .catch(error => defer.reject(null))
    return defer.promise
}

instance.download = async function(url){
    return await axios.get(url, {
            responseType: 'arraybuffer'
        })
        .then(response => {
            console.log(response)
            let blob = new Blob([response.data], { type: 'application/pdf' }),
            url = window.URL.createObjectURL(blob)

            window.open(url) // Mostly the same, I was just experimenting with different approaches, tried link.click, iframe and other solutions
        })
}

// 생성한 인스턴스를 익스포트 합니다.
export default instance;

